<template>
  <div class="detail-box position-header" v-loading="loading">
    <navHeader :titleList="['配对会主题',title + '配对会主题']"/>
    <div class="detail-content common-padding">
      <el-card class="box-card">
        <el-row type="flex" justify="center">
          <el-col :span="10">
            <el-form ref="form" class="add-form" :rules="rules" :model="form" label-width="180px">
              <el-form-item label="标题：" prop="title">
                <el-input v-model.trim="form.title"></el-input>
              </el-form-item>
              <el-form-item label="开始时间：" prop="startTime">
                <el-date-picker style="width: 100%" v-model="form.startTime" type="datetime"
                                format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间：" prop="endTime">
                <el-date-picker style="width: 100%" v-model="form.endTime" type="datetime"
                                format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="是否可报名多场配对会：" prop="repeatStatus">
                <el-radio-group v-model="form.repeatStatus">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="简介：" prop="introduce">
                <el-input v-model.trim="form.introduce" type="textarea" :rows="4"></el-input>
              </el-form-item>
            </el-form>
            <div class="info-footer">
              <el-button type="primary" @click="save">确定</el-button>
              <el-button @click="back">取消</el-button>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import navHeader from '../../components/navHeader.vue'

export default {
  name: 'mateMeetTopicDetail',
  data () {
    return {
      loading: true,
      id: '',
      title: '添加',
      type: 'add',
      form: {
        title: '',
        startTime: '',
        endTime: '',
        repeatStatus: '',
        introduce: ''
      },
      rules: {
        title: {
          required: true, message: '请输入标题', trigger: 'blur'
        },
        startTime: {
          required: true, message: '请选择开始时间', trigger: 'blur'
        },
        endTime: {
          required: true, message: '请选择结束时间', trigger: 'blur'
        },
        repeatStatus: {
          required: true, message: '请选择是否可报名多场配对', trigger: 'blur'
        }
      }
    }
  },
  components: {
    navHeader
  },
  created () {
    if (this.$route.params.id) {
      this.id = this.$route.params.id
      this.getDetail(this.id)
    } else {
      this.id = ''
    }
    if (this.$route.params.type) {
      this.type = this.$route.params.type
      this.title = '编辑'
    } else {
      this.type = 'add'
      this.loading = false
      this.title = '添加'
    }
  },
  methods: {
    getDetail (id) {
      this.$http.post('/mateMeet/getById', {id}).then(res => {
        if (res.data.code === '200') this.form = res.data.data
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    getPosterUrl (list) {
      this.form.posterUrl = list.join(',')
    },
    back () {
      this.$router.back()
    },
    save () {
      this.$refs.form.validate(val => {
        if (val) {
          const params = JSON.parse(JSON.stringify(this.form))
          const url = this.type === 'add' ? '/mateMeet/add' : '/mateMeet/update'

          this.$http.post(url, params).then(res => {
            if (res.data.code === '200') {
              this.$message.success(res.data.msg)
              this.$router.back()
            } else {
              this.$message.error(res.data.msg)
            }
          }).catch(e => {
            console.log(e)
          })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/mateMeetTopic/detail.vue